import styles from './ThreeDotLoader.module.css';

export default function ThreeDotLoader() {
  return (
    <div className={styles.threeBody} aria-hidden="true">
      <span className={styles.threeBodyDot} />
      <span className={styles.threeBodyDot} />
      <span className={styles.threeBodyDot} />
    </div>
  );
}
